function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 306,
  height: 140,
  fill: "white",
  fillOpacity: 0.9
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M109.847 58.8975H112.679L123.287 72.9789H123.34V59.4319H127.268V79.9796H124.436L113.829 65.8982H113.774V79.5786H109.847V58.8975Z",
  fill: "#53535D"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M133.217 73.6211C133.217 75.2778 133.859 77.1487 135.809 77.1487C137.038 77.1487 137.813 76.4002 138.321 75.3586L141.768 75.9193C140.859 78.5378 138.562 80.0076 135.81 80.0076C131.748 80.0076 129.263 77.1215 129.263 73.1411C129.263 69.1599 131.374 66.0342 135.623 66.0342C139.925 66.0342 141.848 69.2134 141.848 73.1683V73.6229H133.217V73.6211ZM138.321 71.2966C138.134 69.9601 137.279 68.6509 135.837 68.6509C134.34 68.6509 133.512 69.9338 133.324 71.2966H138.321Z",
  fill: "#53535D"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M147.256 66.46V73.5669C147.256 75.063 147.497 76.8532 149.394 76.8532C151.292 76.8532 151.531 75.063 151.531 73.5669V66.46H155.272V74.182C155.272 78.0027 153.295 80.007 149.394 80.007C145.493 80.007 143.515 78.0027 143.515 74.182V66.46H147.256Z",
  fill: "#53535D"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M161.51 67.8233H161.564C162.312 66.6738 163.435 66.0332 164.824 66.0332C165.358 66.0332 165.893 66.1666 166.374 66.3535L165.919 69.8276C165.465 69.5073 164.931 69.3467 164.369 69.3467C161.777 69.3467 161.511 71.6449 161.511 73.6754V79.5802H157.771V66.4605H161.511V67.8233H161.51Z",
  fill: "#53535D"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M179.965 79.5792H176.278V78.377H176.224C175.423 79.4186 174.034 80.0066 172.671 80.0066C168.823 80.0066 166.632 76.5062 166.632 72.9523C166.632 69.4782 168.85 66.0322 172.618 66.0322C173.981 66.0322 175.37 66.6193 176.279 67.689V66.4605H179.966V79.5792H179.965ZM176.653 73.0067C176.653 71.2438 175.45 69.3457 173.527 69.3457C171.603 69.3457 170.428 71.2429 170.428 73.0067C170.428 74.7705 171.603 76.694 173.527 76.694C175.45 76.694 176.653 74.7696 176.653 73.0067Z",
  fill: "#53535D"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M186.277 79.5791H182.537V56.9209H186.277V79.5791Z",
  fill: "#53535D"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M197.604 79.5794H195.092V59.4326H197.978C204.177 59.4326 206.101 61.5702 206.101 65.2575C206.101 69.5055 202.867 71.136 199.047 71.136H197.604V79.5794ZM197.604 68.8913H198.406C200.971 68.8913 203.75 68.4104 203.75 65.204C203.75 62.0511 200.757 61.6773 198.273 61.6773H197.605V68.8913H197.604Z",
  fill: "#53535D"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M219.3 73.3535C219.3 77.1206 216.361 80.0068 212.62 80.0068C208.879 80.0068 205.94 77.1206 205.94 73.3535C205.94 69.5863 208.879 66.7002 212.62 66.7002C216.361 66.7002 219.3 69.5863 219.3 73.3535ZM208.345 73.3535C208.345 75.7052 210.242 77.7085 212.62 77.7085C214.998 77.7085 216.895 75.7052 216.895 73.3535C216.895 70.9754 214.998 68.9984 212.62 68.9984C210.241 68.9984 208.345 70.9754 208.345 73.3535Z",
  fill: "#53535D"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M230.749 70.6279C229.787 69.5328 228.611 68.9449 227.169 68.9449C224.818 68.9449 223 71.029 223 73.3272C223 75.8921 224.792 77.763 227.328 77.763C228.718 77.763 229.841 77.1215 230.749 76.1062V79.1784C229.654 79.7663 228.559 80.0068 227.302 80.0068C223.616 80.0068 220.595 77.1741 220.595 73.4333C220.595 69.5591 223.588 66.7002 227.435 66.7002C228.558 66.7002 229.787 66.9679 230.748 67.5286V70.6279H230.749Z",
  fill: "#53535D"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M235.813 71.7774L240.515 67.0748H243.695L238.351 72.2582L244.229 79.5793H241.103L236.641 73.8878L235.813 74.7161V79.5793H233.408V56.3867H235.813V71.7774Z",
  fill: "#53535D"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M246.37 73.7282C246.396 75.8658 247.84 77.8691 250.137 77.8691C251.981 77.8691 252.97 76.9337 253.878 75.4376L255.909 76.5862C254.733 78.7501 252.542 80.0068 250.11 80.0068C246.289 80.0068 243.965 77.1206 243.965 73.4333C243.965 69.5854 246.023 66.7002 250.057 66.7002C254.039 66.7002 255.909 69.6399 255.909 73.3535V73.7282H246.37ZM253.504 71.9109C253.21 70.04 251.981 68.7852 250.057 68.7852C248.187 68.7852 246.797 70.1207 246.503 71.9109H253.504Z",
  fill: "#53535D"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M260.648 79.5789H258.244V69.3191H256.935V67.0744H258.244V62.292H260.648V67.0744H263V69.3191H260.648V79.5789Z",
  fill: "#53535D"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M87.7075 61.1867C83.5765 58.2007 77.807 59.1289 74.821 63.2599C72.2053 66.8782 72.5936 71.7522 75.5051 74.9133L73.1806 78.1288C72.0864 77.6334 70.9278 77.3703 69.7682 77.3222L67.686 64.3768C69.3228 63.7607 70.8044 62.6756 71.9059 61.1522C74.8918 57.0212 73.9636 51.2517 69.8327 48.2657C65.7017 45.2798 59.9321 46.2079 56.9462 50.3389C54.3304 53.9572 54.7187 58.8322 57.6303 61.9933L55.3058 65.2088C51.3907 63.435 46.6401 64.5954 44.0252 68.2138C41.0393 72.3447 41.9675 78.1143 46.0984 81.1002C50.2294 84.0862 55.999 83.158 58.9849 79.027C61.6007 75.4087 61.2123 70.5346 58.3008 67.3736L60.6253 64.1581C61.7186 64.6535 62.8782 64.9166 64.0368 64.9647L66.1191 77.9101C64.4823 78.5271 63.0006 79.6113 61.8992 81.1347C58.9132 85.2657 59.8414 91.0352 63.9724 94.0212C68.1033 97.0071 73.8729 96.079 76.8588 91.948C79.4746 88.3296 79.0863 83.4556 76.1747 80.2945L78.4993 77.079C82.4143 78.8528 87.164 77.6924 89.7798 74.074C92.7667 69.9422 91.8385 64.1726 87.7075 61.1867Z",
  fill: "#304280"
});

var _ref16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b",
  x: -4,
  y: -4,
  width: 314,
  height: 148,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})));

function SvgLogoNeuralpocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 140,
    viewBox: "0 0 306 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNeuralpocket);
export default __webpack_public_path__ + "static/media/logo_neuralpocket.4ad4d75a.svg";
export { ForwardRef as ReactComponent };